















import Vue from 'vue'

export default Vue.extend({
  name: 'RedirectingLogin',
  data () {
    return {
      count: 3
    }
  },
  computed: {
    currentLocation (): string {
      const rawString = window.location.href.replace(this.$route.path, '')
      return rawString + '/login-response'
    },
    href (): string {
      return process.env.VUE_APP_SEDE_URL + this.currentLocation
    }
  },
  mounted () {
    this.countDown()
  },
  methods: {
    onRedirect (): void {
      window.open(this.href, '_self')
    },
    countDown (): void {
      if (this.count > 0) {
        this.count--
        setTimeout(() => { this.countDown() }, 1000)
      } else { this.onRedirect() }
    }
  }
})
